//TODO -- Need to maintain Loader's visibilty throw context to avoid declaring states in every component

// ** React Imports
import * as React from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import CircularProgress, { circularProgressClasses, CircularProgressProps } from '@mui/material/CircularProgress'

export const CircularLoader: React.FC<CircularProgressProps> = props => {
  return (
    <Box sx={{ position: 'relative' }}>
      <CircularProgress
        variant='determinate'
        sx={{
          color: theme => theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800]
        }}
        size={40}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant='indeterminate'
        disableShrink
        sx={{
          color: theme => (theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8'),
          animationDuration: '550ms',
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round'
          }
        }}
        size={40}
        thickness={4}
        {...props}
      />
    </Box>
  )
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface LoaderProps {}

const Loader: React.FC<LoaderProps> = ({}) => {
  return (
    <Box sx={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <CircularLoader />
    </Box>
  )
}

export default Loader
